/* Festive Landing Page - countdown timer */
(function () {
  'use strict';

  const el = document.querySelector('[data-countdown]');
  if (!el) return;

  const target = new Date(el.dataset.countdown + 'T00:00:00');
  if (isNaN(target.getTime())) return;

  const days = el.querySelector('[data-days]');
  const hours = el.querySelector('[data-hours]');
  const minutes = el.querySelector('[data-minutes]');

  function update() {
    const diff = target - Date.now();
    if (diff <= 0) {
      el.remove();
      return;
    }
    const d = Math.floor(diff / 864e5);
    const h = Math.floor((diff % 864e5) / 36e5);
    const m = Math.floor((diff % 36e5) / 6e4);
    days.textContent = d;
    hours.textContent = String(h).padStart(2, '0');
    minutes.textContent = String(m).padStart(2, '0');
    el.hidden = false;
  }

  update();
  setInterval(update, 60000);
})();
